import {Button} from "@zendeskgarden/react-buttons";
import {Body, Close, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {Input} from "@zendeskgarden/react-forms";
import {ReactElement, useState} from "react";
import * as css from "./forecast-locks-warning-modal.module.scss";

export type ForecastLocksWarningModalProps = {
    onAccept: () => void;
    onCancel: () => void;
};

const ExpectedText = "update anyway";

export default function ForecastLocksWarningModal({onAccept, onCancel}: ForecastLocksWarningModalProps): ReactElement {
    const [inputVal, setInputVal] = useState("");

    return (
        <Modal onClose={onCancel} className={css.wrapper}>
            <Header isDanger className={css.header}>
                Finalized Budgets Warning
            </Header>
            <Body>
                <p>
                    Some properties have finalized budgets. Saving changes to the Chart of Accounts may potentially affect the budgets for these properties.
                </p>
                <h5>Enter "{ExpectedText}" to confirm.</h5>
                <Input
                    type="text"
                    aria-label={`Enter "${ExpectedText}" to confirm.`}
                    placeholder={ExpectedText}
                    value={inputVal}
                    onChange={(e) => setInputVal(e.target.value)}
                />
                <div className={css.warningWrapper}>
                    <h5 className={css.warningText}>THIS ACTION CANNOT BE UNDONE</h5>
                </div>
            </Body>
            <Footer>
                <FooterItem>
                    <Button onClick={onCancel} isBasic>
                        Cancel
                    </Button>
                </FooterItem>
                <FooterItem>
                    <Button
                        isPrimary
                        isDanger
                        onClick={onAccept}
                        disabled={inputVal !== ExpectedText}
                    >
                        Save Changes
                    </Button>
                </FooterItem>
            </Footer>
            <Close aria-label="Close modal" />
        </Modal>
    );
}
